<h2>{{'DETAIL' | translate | titlecase}} {{datasetACS.datasetConfig.singleTitle | translate | titlecase}}</h2>
<div class="trip_data">
  @if (datasetACS.actionConfig && datasetACS.actionConfig.viewConfig.formConfig) {
    <div class="trip_details">
      <div card-data-viewer
        [record]='datasetRS.record.value'
        [datasetACS]='datasetACS'
        [viewFormConfig]='datasetACS.actionConfig.viewConfig.formConfig'
        [editFormConfig]='editFormConfig'
      ></div>
      <!-- Confirmed participants -->
      @if (datasetRS.record.value.participant_overall.total > 0) {
        <div class='participant-list'>
          <div class="rettangolo" [class.notall]='datasetRS.record.value.participant_overall.total != datasetRS.record.value.total_participants_confirmed'></div>
          <div class="total_participants" (click)='openList()'>
            <span class="material-icons icon">groups</span>
            <span class="totals">{{ datasetRS.record.value.total_participants_confirmed }}/{{ datasetRS.record.value.participant_overall.total }}</span>
            <!-- spinner for websocket -->
            @if (datasetRS.loading.value) {
              <div class="spinner">
                <mat-spinner [diameter]='20'></mat-spinner>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
  @if (package) {
    <div class="package_details">
      <mat-card class="mat-elevation-z0 details-departure">
        @if (package.master_image) {
          <img mat-card-image alt='Immagine di copertina' [src]='appService.getBaseServerAddressRoot() + "/document_files/download/" + package.master_image'/>
        }
        <mat-card-content>
          <div class="name-trip-detail">
            <a [routerLink]='"/dataset/detail/trip_packages/" + package.id'>{{package.description}}</a>
          </div>
          <table>
            <tbody>
              <tr>
                <td>{{'Codice' | translate}}</td>
                <td><span>{{package.code}}</span></td>
              </tr>
              @if (package.destinations) {
                <tr>
                  <td>{{'Destinazioni' | translate}}</td>
                  <td><ul>@for (destination of package.destinations; track destination) {
                    <li>{{destination.description}}</li>
                  }</ul></td>
                </tr>
              }
              @if (package.properties.price.value) {
                <tr>
                  <td>{{'Prezzo al pubblico' | translate}}</td>
                  <td><span>{{package.properties.price.value | currency:'EUR'}}</span></td>
                </tr>
              }
              @if (package.properties.email.value) {
                <tr>
                  <td>{{'Email' | translate}}</td>
                  <td><span>{{package.properties.email.value}}</span></td>
                </tr>
              }
              @if (package.properties.phone.value) {
                <tr>
                  <td>{{'Telefono' | translate}}</td>
                  <td><span>{{package.properties.phone.value}}</span></td>
                </tr>
              }
            </tbody>
          </table>
          @if (package.properties.note_booking.value) {
            <div>
              <span class='h2'>{{'Note' | translate}}</span>
              <div style='padding: 8px;border: 1px solid #eee;border-radius: 8px;'>
                {{package.properties.note_booking.value}}
              </div>
            </div>
          }
        </mat-card-content>
      </mat-card>
    </div>
  }
</div>

@if (datasetRS.record.value && !resellView) {
  <div class="mt-16 mb-16 participant-list-btn fx-row fx-justify-start fx-items-start fx-xs-column" style="gap: 10px">
    <mat-card class="mat-elevation-z0 details-departure fx-flex fx-fill">
      <mat-card-content>
        <a mat-button mat-flat-button [matMenuTriggerFor]="menu" color='accent'>{{'Lista partecipanti' | translate}}</a>
        <mat-menu #menu="matMenu">
          <a mat-menu-item [href]='participantListUrl()' target="_blank">{{'Stampa' | translate}}</a>
          <button mat-menu-item (click)="viewEmailInput()">{{'Invia via mail' | translate}}</button>
        </mat-menu>
      </mat-card-content>
    </mat-card>
  </div>
}

<mat-tab-group>
  @if (showBooking) {
    <mat-tab [label]='"Prenotazioni" | translate'>
      <ng-template matTabContent>
        <dataset-list
          [showTitle]='false'
          [elevate]='false'
          datasetCode='trip_booking_report_views'
          [parentDatasetACS]='datasetACS'
          [parentDatasetRS]='datasetRS'
          [filters]='{actual_trip_id: datasetRS.recordId }'
          [cacheDatasetListFilters]='false'
          [autoFetchData]='false'
          [showExportBtn]='false'
          [contextualDomainId]='contextualDomainId'
        ></dataset-list>
      </ng-template>
    </mat-tab>
  }
  @if (!resellView) {
    @if (externalSyncedType == 0) {
      <mat-tab [label]="'Risorse' | translate">
        <ng-template matTabContent>
          <dataset-list
            [showTitle]='false'
            [elevate]='false'
            datasetCode='actual_trip_resources'
            [parentDatasetACS]='datasetACS'
            [parentDatasetRS]='datasetRS'
            [filters]='{actual_trip_id: datasetRS.recordId }'
            [showSearchBar]='false'
            >
          </dataset-list>
        </ng-template>
      </mat-tab>
    }
    @for (resource of tripResourceWithStaff; track trackById($index, resource)) {
      <mat-tab [label]='"Accompagnatori" | translate'>
        <ng-template mat-tab-label>
          {{'Accompagnatori risorsa' | translate}}: {{resource.description}}
        </ng-template>
        <dataset-list
          [showTitle]='false'
          [autoFetchData]='true'
          datasetCode='trip_resource_staff_assignments'
          [parentDatasetRS]='datasetRS'
          [parentDatasetACS]='datasetACS'
          [showSearchBar]='false'
          [elevate]='false'
          [filters]='{ date: datasetRS.record.value.start_day, actual_trip_id: datasetRS.recordId, trip_resource_id: resource.id}'
          [viewConfig]='tripResourceStaffAssignmentsTableView'
          [enableCreate]='false'
          >
        </dataset-list>
      </mat-tab>
    }
    @if (canConfirmPresence) {
      <mat-tab [label]='"Partecipanti" | translate'>
        <ng-template matTabContent>
          <actual-trip-participants-tab
            [actualTripId]='datasetRS.recordId'
            [canEdit]='canConfirmPresence'
            (presenceChanged)='datasetRS.reload()'>
          </actual-trip-participants-tab>
        </ng-template>
      </mat-tab>
    }
  }
</mat-tab-group>
